import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdataAmat() {
	let obj = {
		formdata: {
			id: '-1',
			accountCode: '',
			accountType: '',
			accountLevel: '',
			accountDesc: '',
			debitCreditType: '',
			lastAccountLevel: '',
			accountingDate: '',
			ref1: '',
			ref2: '',
			ref3: '',
			ref4: '',
			ref5: '',
			cfkm: ''
		},
		formlist:[
			{
				prop: "accountCode",
				label: "中方科目代码",
				type: "select",
				isnotnull: true,
				slot: true,
			},
			{
				prop: "accountType",
				label: "中方科目类型",
				type: "select",
				isnotnull: true,
				selectval: [],
				width: "230px"
			},
			{
				prop: "accountLevel",
				label: "科目级别",
				type: "select",
				isnotnull: true,
				selectval: [],
				width: "230px"
			},
			{
				prop: "lastAccountLevel",
				label: "是否末级科目",
				type: "radio",
				isnotnull: true,
				radioval: comMapping.$sf,
			},
			{
				prop: "ref1",
				label: "报表类型",
				type: "input",
				width: "230px"
			},
			{
				prop: "ref2",
				label: "报表科目",
				type: "input",
				width: "230px"
			},
			{
				prop: "cfkm",
				label: "CF科目",
				type: "input",
				width: "230px"
			},
			{
				prop: "accountDesc",
				label: "中方科目描述",
				type: "input",
				isnotnull: true,
				width: "230px"
			},
			{
				prop: "debitCreditType",
				label: "借贷类型",
				type: "select",
				isnotnull: true,
				selectval: comMapping.$fzlx,
				width: "230px"
			},
			{
				prop: "accountingDate",
				label: "是否年结科目",
				type: "radio",
				isnotnull: true,
				radioval: comMapping.$sf,
			},
			{
				prop: "ref3",
				label: "科目特殊标识3",
				type: "input",
				width: "230px"
			},
			{
				prop: "ref4",
				label: "科目特殊标识4",
				type: "input",
				width: "230px"
			},
			{
				prop: "ref5",
				label: "科目特殊标识5",
				type: "input",
				width: "230px"
			}
		],
		headData: [{
				title: "中方科目代码",
				prop: "accountCode",
				width: "120",
				issort: true,
			},
			{
				title: "科目描述",
				prop: "accountDesc",
				width: "100",
				issort: true

			},
			{
				title: "科目类型",
				prop: "accountType",
				width: "100",
				custom: true,
				issort: true,
			},
			{
				title: "科目级别",
				prop: "accountLevel",
				width: "100",
				// custom: true,
				issort: true,
			},
			{
				title: "借贷类型",
				prop: "debitCreditType",
				width: "100",
				custom: true,
				issort: true,
			},
			{
				title: "是否末级科目",
				prop: "lastAccountLevel",
				width: "120",
				custom: true,
				issort: true,
			}, {
				title: "是否年结科目",
				prop: "accountingDate",
				width: "120",
				custom: true,
				issort: true,
			}, {
				title: "CF科目",
				prop: "cfkm",
				width: "120",
				issort: true,
			}, {
				title: "创建时间",
				prop: "createDate",
				width: "100",
				issort: true,
			}, {
				title: "更新时间",
				prop: "updateDate",
				width: "100",
				issort: true,
			}, {
				title: "最近操作人",
				prop: "creator",
				width: "120",
				issort: true,
			}, {
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		searchlist: [{
				prop: "accountCode",
				label: '中方科目代码',
				type: "input",
			},
			{
				prop: "accountType",
				label: '科目类型',
				type: "select",
				selectval: []
			},
			{
				prop: "accountDesc",
				label: '中方科目描述',
				type: "input"
			}
		]
		
	}
	return obj
}
